<template>
    <div class="form-date">
        <table>
          <tr>
            <td style="border-right: 2px solid gray;width: 50%;">
              <input type="text" readonly="" :value="dateFrom" @click="showDate" style="width: 100%;height: 100%;border: none;padding-left: 36px;padding-top: 25px;">
            </td>
            <td style="width: 50%;position: relative;">
              <input class="langKh" type="text" readonly="" :value="dateTo" @click="showDateBack" :placeholder="$t('message.selectDate')" style="width: 100%;height: 100%;border: none;padding-left: 35px;padding-top: 24px;">
              <span class="langKh" style="font-weight: 700;color: rgba(0, 0, 0, 0.6);position: absolute;top: 5px;left: 12px;">{{$t('message.returnDate')}}</span>
              <font-awesome-icon style="position: absolute;top: 33px;left: 13px;font-size: 18px;color: rgba(0, 0, 0, 0.6);font-weight: 600;" icon="fa-solid fa-calendar-days" />
              <font-awesome-icon v-if="showIcon" @click="clearDateTo" icon="fa-solid fa-xmark" style="font-size: 20px;position: absolute; top: 33px; right: 15px; color: #de5d0a;" />
            </td>
          </tr>
          <span class="langKh" style="font-weight: 700;color: rgba(0, 0, 0, 0.6);position: absolute;top: 178px;left: 31px;">{{$t('message.departureDate')}}</span>
          <font-awesome-icon style="position: absolute;top: 206px;left: 32px;font-size: 18px;color: rgba(0, 0, 0, 0.6);font-weight: 600;" icon="fa-solid fa-calendar-days" />
        </table>
        <van-calendar :title="$t('message.calendar')" color="#de5d0a" v-if="showDeteFrom" :min-date="new Date()" v-model:show="show" :show-confirm="false" @confirm="onConfirmDateFrom" :style="{ height: '90%' }" :class="{langKh: addFontKhmer}" />
        <van-calendar :title="$t('message.calendar')" color="#de5d0a" v-if="showDeteTo" :min-date="new Date(this.dateFrom)" v-model:show="show" :show-confirm="false" @confirm="onConfirmDateTo" :style="{ height: '90%' }" :class="{langKh: addFontKhmer}" />
    </div>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        return {
            showIcon: false,
            show: false,
            dateFrom: localStorage.getItem('dateFrom'),
            dateTo: localStorage.getItem('dateTo'),
            showDeteFrom: false,
            showDeteTo: false,
        }
    },
    methods: {
        clearDateTo() {
            this.dateTo = '';
            localStorage.removeItem('dateTo');
            this.showIcon = false;
            if(localStorage.getItem('dateFrom') == null || localStorage.getItem('dateFrom') == '') {
                this.dateFrom = this.getDateNow();
                localStorage.setItem('dateFrom', this.getDateNow());
            }
        },
        removeIcon() {
            if(localStorage.getItem('dateTo') != '' && localStorage.getItem('dateTo') != null) {
                this.showIcon = true;
            }else {
                this.showIcon = false;
            }
        },
        showDate() {
            localStorage.setItem("dateDialog", 1);
            this.show = true;
            this.showDeteFrom = true;
            this.dateTo = '';
            localStorage.removeItem('dateTo');
            this.showIcon = false;
            this.showDeteTo = false;
        },
        closedPoDate() {
            localStorage.setItem("dateDialog", 0);
            this.showDeteFrom = false;
        },
        showDateBack() {
            localStorage.setItem("dateDialog", 1);
            this.show = true;
            this.showDeteTo = true;
            this.showDeteFrom = false;
        },
        closedPoDateTo() {
            localStorage.setItem("dateDialog", 0);
            this.showDeteTo = false;
        },
        getDateNow(){
            return moment().format('YYYY-MM-DD');
        },
        formatDate(date) {
            if(date != ''){
                return moment(String(date)).format('YYYY-MM-DD');
            } else{
                return '';
            }
        },
        onConfirmDateFrom(selectDateFrom) {
            this.dateFrom = this.formatDate(selectDateFrom);
            this.show = false;
            localStorage.setItem('dateFrom', this.dateFrom);
        },
        onConfirmDateTo(selectDateTo) {
            this.dateTo = this.formatDate(selectDateTo)
            this.show = false;
            this.showIcon = true;
            localStorage.setItem('dateTo', this.dateTo);
        }
    },
    
    created() {
        if(localStorage.getItem("lang") == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }
        // Set Date From
        this.removeIcon();
        
        if(localStorage.getItem('dateFrom') == null || localStorage.getItem('dateFrom') == '') {
            this.dateFrom = this.getDateNow();
            localStorage.setItem('dateFrom', this.getDateNow());
        }
    },
}
</script>

<style>
    .form-date {
        width: 100%;
        margin-top: 8px;
    }
    .form-date table {
        width: 100%;
        border: 1px solid #de5d0a;
        border-radius: 8px;
        height:70px;
    }
</style>